module.exports = __webpack_public_path__ + "static/img/biederstein-logo-transparent.da65671d.png";